const EXTENSION_BY_MIME_TYPE = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
}

const DEFAULT_EXTENSION = 'png'

const saveBlob = (blob, fileName) => {
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(objectUrl)
}

// Generated images are served from the signed generator-assets CDN, so the `download`
// attribute is cross-origin and browsers navigate to the image instead of saving it.
// Fetching the bytes first keeps the save local; the CDN answers with CORS headers (the
// Edit tab reads the same URLs into a canvas with crossOrigin 'anonymous'). The extension
// comes from the response type because the signed key carries none. The failure copy
// is passed in already translated because this module has no hook context of its own.
export default function downloadImage(url, baseName, failureMessage) {
  if (!url) {
    return Promise.resolve(false)
  }

  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Image download failed with status ${response.status}`)
      }
      return response.blob()
    })
    .then((blob) => {
      saveBlob(blob, `${baseName}.${EXTENSION_BY_MIME_TYPE[blob.type] || DEFAULT_EXTENSION}`)
      return true
    })
    .catch(() => {
      if (window.showNotification && failureMessage) {
        window.showNotification(failureMessage, { type: 'error', autohide: true })
      }
      return false
    })
}
